{
  "removeButtonLabel": "Remover",
  "removeDescription": "Pressione Delete para remover a tag."
}
